module.exports = __webpack_public_path__ + "media/img/ms-icon-144x144-1355aeb71ad7602383a2c49d2a3a3123.png";